// extracted by mini-css-extract-plugin
export default {"indexMain":"NotFound_indexMain__6nJA5","label":"NotFound_label__GbdK4","logoImg":"NotFound_logoImg__We4Qb"};